export const IP_BLOCK_CODE = "RB99";
export const IP_BLOCK_MESSAGE = "IPBlockIn5M";
export const DISTANCE_ACCEPT = "distanceAccept";
export const STORAGE_EXPIRED = "browserStorageExpired";
export const HANDSHAKE = "isHandShakeFlg";
export const GEOLOCATION = "isGeolocation";
export const API = "api";
export const REMAINING = "tickAutoClose";
export const MULTILANGUAGE = "isMultiLanguage";
export const SHOW_QRCODE = "isShowQRCode";
export const TIMEOUT = "timeout";
